import { useQuery } from '@tanstack/react-query';
import useGlynt from './useGlynt';

export function useGetRawValue(extractionId: string) {
  const glynt = useGlynt();

  const extractionData = useQuery({
    queryKey: ['extraction', extractionId, { view: 'raw' }],
    queryFn: async () => await (await glynt).extraction.retrieve_raw_result(extractionId),
    refetchOnWindowFocus: false
  });

  return extractionData;
}
